export const ticket_routes = [
  {
    path: "/tickets",
    component: () => import("../Main.vue"),
    name: "Chamados"
  }
];

export default {};
